import React from 'react'
import apiBarcode from '../../../services/api/apiBarcode'
import Loading from '../../../components/Loading/Loading'
import CheckLineItem from './CheckLineItem'
import { getListHistoriesByBarcodeV2 } from "../../../services/api/apiItemHistory"

class CheckContainer extends React.Component {
    state = {
        item: null,
        isLoading: false,
        haveScanToCheck: false,
    }

    componentDidMount() {
        this.fetchItem()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.id !== prevProps.id) {
            this.fetchItem()
        }
    }

    _parseBarcode = () => {
        const { id } = this.props
        if (!id) return false

        if (!id.startsWith('#')) throw new Error('Invalid ID.')

        const trimmedNumber = id.replace('#', '')
        const codes = trimmedNumber.split('_')

        return codes[0]
    }

    fetchItem = async () => {
        const { id } = this.props
        if (!id) return

        this.setState({ isLoading: true })

        try {
            if (!id.startsWith('#')) throw new Error('Invalid ID.')

            const trimmedNumber = id.replace('#', '')
            const codes = trimmedNumber.split('_')
            const resRead = await apiBarcode.getBarcodeByNumber(codes[0], `page=qcPage&item=${codes[1]}`)
            const { success, data, message } = resRead.data

            if (!success) throw Error(message)

            if (!data) throw new Error('No items found.')
            this.setState({item: data}, () => this.getHistories())

            // this.setState({item: data, isLoading: false}, () => {
            //     return pushNewItemHistory(id, {
            //         event_key: 'scan_to_check',
            //         event_description: 'Scan QR to check product quality.'
            //     })
            // })
        } catch (e) {
            alert(e.message)
            this.setState({
                item: null,
                isLoading: false
            })
        }
    }

    getProducts = (id, products) => {
        const splitId = id.split('_')
        const index = splitId[1]
        const i = index && parseInt(index, 10)
        if (i && products[i - 1]) {
            return [
                {
                    ...products[i - 1],
                    index: i - 1
                }
            ]
        }

        return products.map((product, indexItem) => ({ ...product, indexItem }))
    }

    _handleSyncDesign = async (pos, designKey) => {
        console.log('Sync design:', pos, designKey)

        try {
            const barcode = this._parseBarcode()
            console.log('Sync', barcode, pos, designKey)

            const { data: { success, message } } = await apiBarcode.resyncDesign(barcode, pos, designKey)
            if (!success) {
                throw new Error(message)
            }

            return this.fetchItem()
        } catch (e) {
            window.alert(e.message || e)
        }
    }

    getHistories = async () => {
        const { id } = this.props
        try {
            const { data, success, message } = await getListHistoriesByBarcodeV2(id, { page: 1, limit: 10000 })
            if (!success) {
                console.log(message)
            } else {
                const { histories } = data
                this.setState({
                    haveScanToCheck: !!histories && !!histories.filter(i => i.event_key === 'scan_to_check').length
                })
            }
        } catch (error) {
            console.log(error)
        } finally {
            this.setState({ isLoading: false })
        }
    }

    render() {
        const { item, isLoading, haveScanToCheck } = this.state
        const { products: listItems } = Object.assign({}, item)
        const { id, onChangeId } = this.props

        if (isLoading) return <Loading />
        if (!item) return <div>No Item.</div>

        const products = this.getProducts(id, item.products)
        const isBrandKitTag = listItems && Array.isArray(listItems) && listItems.some(item => item.type === "BRAND_KIT")

        return (
            <div className='CheckContainer'>
                {
                    products.map((product, index) => {
                        return <CheckLineItem
                            key={index}
                            product={product}
                            onSyncDesign={this._handleSyncDesign}
                            id={`${item.barcodeNumber}_${product.index + 1}`}
                            isBrandKitTag={isBrandKitTag}
                            reset={this.fetchItem}
                            haveScanToCheck={haveScanToCheck}
                            onChangeId={onChangeId}
                        />
                    })
                }
            </div>
        )
    }
}

export default CheckContainer
